export const isContentEditable = (element: HTMLElement) => {
  const value = element.getAttribute('contenteditable')

  return value !== 'false' && value != null
}
